import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var ActivityPeriod =
/*#__PURE__*/
function (_BaseData) {
  _inherits(ActivityPeriod, _BaseData);

  function ActivityPeriod() {
    _classCallCheck(this, ActivityPeriod);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActivityPeriod).call(this, "ActivityPeriod"));
  }

  _createClass(ActivityPeriod, [{
    key: "GetExpectedActivityPeriod",
    value: function () {
      var _GetExpectedActivityPeriod = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(serviceDateYear) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetExpectedActivityPeriod/").concat(serviceDateYear)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetExpectedActivityPeriod(_x) {
        return _GetExpectedActivityPeriod.apply(this, arguments);
      }

      return GetExpectedActivityPeriod;
    }()
  }]);

  return ActivityPeriod;
}(BaseData);

export default new ActivityPeriod();